import { render, staticRenderFns } from "./BillingPackagesPayment.vue?vue&type=template&id=56899ad6&scoped=true&"
import script from "./BillingPackagesPayment.vue?vue&type=script&lang=ts&"
export * from "./BillingPackagesPayment.vue?vue&type=script&lang=ts&"
import style0 from "./BillingPackagesPayment.vue?vue&type=style&index=0&id=56899ad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56899ad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
